import { EditableTitle } from '@/components/Title/EditableTitle';
import { CampaignFormValues } from '@/pages/campaign/CreatePage/types';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material';
import { useController, useFormContext } from 'react-hook-form';

const StyledEditableTitle = styled(EditableTitle)`
    input {
        color: ${({ theme }) => theme.colors.black[700]};
        font-size: 16px;
        font-weight: 500;
        line-height: 160%;
        letter-spacing: 0.15px;
    }
`;

export const Name = () => {
    const theme = useTheme();
    const { control } = useFormContext<CampaignFormValues>();

    const {
        field: { value, ...rest },
    } = useController({
        name: 'name',
        control,
    });

    return (
        <StyledEditableTitle
            fontSize={18}
            placeholder="Type campaign title"
            color={theme.colors.black[700]}
            showIcon
            value={value || ''}
            {...rest}
        />
    );
};
